module.exports = __webpack_public_path__ + "img/gym_thumbnail-400x300.69a29612.jpg";